// The purpose of this file is store form field constraints (rules, messages) for a HTML form.
// Note that this data is kept separate from the implementation of the system that stores and retrieves data,
// which is located in the 'core' directory.

// Grab a reference to the global namespace application data store as an object.
var dataStore = app.data;

// Note that validation messages should be overriden by the server in the cshtml view files to cater for different languages. The message values here are just fallbacks.

dataStore.set('validation.forgottenPasswordForm', {
    emailAddress: [
        {
            type: 'present',
            errorCode: 10082
        },
        {
            type: 'email',
            errorCode: 10083
        }
    ]
});